exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n  --f7-theme-color: #4F8C54;\n  --f7-theme-color-shade: #4F8C54;\n  --f7-theme-color-tint: #4F8C54;\n  --f7-theme-color-rgb: 79, 140, 84;\n}\n", ""]);
